import { useMemo } from 'react';
import { useAuthContext } from '@lp/core/auth';
import { useLogisticsById } from '@/queries/route-planner';
import { CaseDetailsPermissions } from '@/permissions';
import { CaseStatus } from '@/api/apis/case';
import { getIsEuropeanRegion, isAllowedStatus } from '@/utils/helpers';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';

export const useCanViewLocationTracking = () => {
  const { checkPermission } = useAuthContext();
  const { status, trialProgram, serviceRegionId, logisticsReference } = useBaseCaseDetails();
  const { data: logisticsData } = useLogisticsById(logisticsReference?.id);

  return useMemo(() => {
    const hasPermission = checkPermission(CaseDetailsPermissions.LocationTrackingRead);
    if (!hasPermission) return false;

    const isActiveStatus = isAllowedStatus({
      statusFrom: CaseStatus.ResourceDeployed,
      statusTo: CaseStatus.ReturningToBase,
      currentStatus: status,
    });
    if (!isActiveStatus) return false;

    if (!logisticsData?.isTmdxDriveCompatible) return false;
    if (trialProgram) return false;

    return !getIsEuropeanRegion(serviceRegionId);
  }, [logisticsData, status, checkPermission, trialProgram, serviceRegionId]);
};
